export default __webpack_public_path__ + "static/media/alert.d07b5981.svg";